import { Box, Button, Divider, HStack, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, VStack } from '@chakra-ui/react'
import { Evaluation } from 'interfaces/evaluation'

interface Props {
	isOpen: boolean
	onClose: () => void
	title: string
	evaluations: Evaluation[]
}

const LifeAssessment = ({ isOpen, onClose, title, evaluations }: Props) => {
	return (
		<Modal size="md" onClose={onClose} isOpen={isOpen} isCentered>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{title}</ModalHeader>
				<ModalBody>
					<Box w="full" h="full" maxH="360px" overflowY="auto">
						<VStack spacing={2} divider={<Divider py={1} />}>
							{
								evaluations
									.filter(eva => eva.tag !== 'label' && eva.tag !== 'lgpd' && eva.value !== null && eva.value !== "")
									.sort((a, b) => a.order > b.order ? 1 : -1)
									.map(eva => {
										if(eva.tag == 'imc') {
											const data = JSON.parse(eva.data)
											return (
												<VStack>
													<Text size="md">{eva.key}</Text>
													<Text size="md" fontWeight="bold">{`${data.weight}kg / ${data.height}cm`}</Text>
												</VStack>
											);
										} else {
											return (
												<VStack>
													<Text size="md">{eva.key}</Text>
													<Text size="md" fontWeight="bold">{eva.value}</Text>
												</VStack>
											)
										}

									}
								)
							}
						</VStack>
					</Box>
				</ModalBody>
				<ModalFooter>
					<HStack spacing={4}>
						<Button variant="ghost" onClick={onClose}>Fechar</Button>
					</HStack>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default LifeAssessment
